import { render, staticRenderFns } from "./page3.vue?vue&type=template&id=1ef53bd6&scoped=true"
import script from "./page3.vue?vue&type=script&lang=js"
export * from "./page3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef53bd6",
  null
  
)

export default component.exports